import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-taxonomy-campaign-view-column-header',
  templateUrl: './campaign-view-column-header.component.html',
  styleUrls: ['./campaign-view-column-header.component.scss']
})
export class CampaignViewColumnHeaderComponent {
  @Input() header = '';
  @Input() headerStyleClass = '';
  @Input() headerStyle: Record<string, string> = {};
  @Input() searchValue = '';

  @Output() searchValueChange = new EventEmitter<string>();

  showSearchBox = false;

  toggleSearchBox() {
    this.showSearchBox = !this.showSearchBox;
  }

  publishSearchValue() {
    this.searchValueChange.emit(this.searchValue);
  }

  clearSearchText() {
    this.searchValue = '';
    this.searchValueChange.emit(this.searchValue);
  }
}
